import React from "react";
import { Link } from "react-router-dom";
import { AUTH_LOGO_INLINE } from "@/lib/authLogoInline";

export const AuthPageBrand = ({ testIdPrefix }) => {
  return (
    <Link
      to="/"
      className="fixed top-4 left-4 z-20 inline-flex items-center gap-3 rounded-full border border-border/70 bg-background/85 px-4 py-2 backdrop-blur transition-[background-color,border-color] duration-200 hover:border-primary/50 hover:bg-background"
      data-testid={`${testIdPrefix}-home-link`}
      aria-label="Go to landing page"
    >
      <img
        src={AUTH_LOGO_INLINE}
        alt="Voxara"
        className="h-8 w-auto"
        width="120"
        height="80"
        loading="eager"
        fetchPriority="high"
        decoding="sync"
        data-testid={`${testIdPrefix}-home-logo-image`}
      />
      <span
        className="text-sm font-semibold tracking-[0.18em] text-foreground/90 uppercase"
        data-testid={`${testIdPrefix}-home-logo-text`}
      >
        Voxara
      </span>
    </Link>
  );
};